module.exports = __webpack_public_path__ + "img/draw2_img7.7a18a9d4.png";